module.exports = __webpack_public_path__ + "static/media/Driveway-parking.64821de3.png";